import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'lang',
  state: {
    langList: [],
    langParams: {},
    langPagination: {},
    lang_example: ''
  },
  effects: {
    *getLangList({ payload }, { call, put, select }) {
      const params = yield select((state) => state.lang.langParams);
      const res = yield call(API.getLangList, { ...params, ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            langList: data.data,
            langParams: { ...params, ...payload },
            langPagination: data.pagination,
            lang_example: data.lang_example
          },
        });
      }
    },

    *addLang({ payload }, { call, put }) {
      yield put({
        type: 'save',
        payload: {loading: true}
      })
      const res = yield call(API.addLang, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getLangList',
        });
      } else {
        message.error(res.message);
      }
      yield put({
        type: 'save',
        payload: {loading: false}
      })
    },
    *delLang({ payload }, { call, put }) {
      const res = yield call(API.delLang, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getLangList',
        });
      } else {
        message.error(res.message);
      }
    },
    *editLang({ payload }, { call, put }) {
      const res = yield call(API.editLang, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getLangList',
        });
      } else {
        message.error(res.message);
      }
    },
    *exportLang({ payload }, { call }) {
      const res = yield call(API.exportLang, payload);
      if (res.code === 0) {
        window.location.href = res.data.file_url
        console.log(res)
      } else {
        message.error(res.message);
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
